/* eslint-disable no-undef */
export function createDiv(divId, tragetId) {
  const newDiv = document.createElement('div');
  newDiv.id = divId;
  const target = document.getElementById(tragetId);
  target.appendChild(newDiv);
}

export function getDivIdForAd(targetId) {
  return `${targetId}-ext`;
}

export function getDivIdForContent(targetId) {
  return `${targetId}-content`;
}
export function checkContainerbyId(divId) {
  return document.getElementById(divId);
}

export function createAdAndContentDivs(config) {
  const { targetId } = config;
  if (checkContainerbyId(targetId)) {
    document.getElementById(targetId).style.position = 'relative';
    createDiv(getDivIdForAd(targetId), targetId);
    document.getElementById(getDivIdForAd(targetId)).classList.add('tpx-ext');

    createDiv(getDivIdForContent(targetId), targetId);
    document.getElementById(getDivIdForContent(targetId)).classList.add('tpx-content');

    if (config.format === 'vertical') {
      document.getElementById(getDivIdForAd(targetId)).classList.add('vertical');
      document.getElementById(getDivIdForContent(targetId)).classList.add('vertical');
    }
    // document.getElementById(getDivIdForContent(targetId)).style.position = 'absolute';
    // document.getElementById(getDivIdForContent(targetId)).style.width = '100%';
    // document.getElementById(getDivIdForContent(targetId)).style.height = '100%';
    return true;
  }
  return false;
}

export function showDiv(targetId, show) {
  if (checkContainerbyId(targetId)) {
    document.getElementById(targetId).style.display = show ? 'block' : 'none';
  }
}
